export default __webpack_public_path__ + "static/media/avatar.a678e80e.svg";